// extracted by mini-css-extract-plugin
export default {"modalContent":"modalContent-PRqKA","header":"header-e_Qq7"};